export default __webpack_public_path__ + "static/media/rnr-sports-table-25.6868133c.webp";